import PropTypes from 'prop-types';

import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import css from 'styles/components/search/topBannerAd.scss';

const TopBannerAd = (_, { marketplace: { shortName, hasBannerAds } }) => {
  if (!hasBannerAds) {
    return null;
  }
  return (
    <div className={css.innerWrapper}>
      {/* Just a placeholder container until Symphony wiring, where we'll use LandingPageLink */}
      <img alt="derp" src="https://github01.zappos.net/storage/user/668/files/15e16600-d938-11e9-82d5-489d0f2933f6" />
      <Tooltip
        content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
        wrapperClassName={css.tooltipWrapper}
        tooltipClassName={css.tooltip}
        contentClassName={css.content}
        direction="down"
        tooltipId="topBannerAd"
      >
      Sponsored <MoreInfo />
      </Tooltip>
    </div>
  );
};

TopBannerAd.contextTypes = {
  marketplace: PropTypes.object
};

export default TopBannerAd
;
